import {query} from "../../utilities/query";
import {createAction} from "redux-actions";

export const fetchSigntasks = Object.assign(() => (dispatch, getState) => {
  const {signtasks: {meta}} = getState();
  const nextPage = Math.max(-1, ...meta.loadedPages) + 1;
  const numPages = meta.numPages || Infinity;

  if (nextPage < numPages) {
    return dispatch(query(fetchSigntasks)("/api/signtask", "GET", {page: nextPage, pageSize: 10}));
  }
}, {
  success: createAction(
    "signtasks/FETCH_MORE_SUCCESS",
    json => json.elements,
    (json, meta) => ({...meta, numElements: json.total, numPages: json.pages})
  ),
  failure: createAction("signtasks/FETCH_MORE_FAILURE")
});
